<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card success-card">
          <div class="card-body green">You successfully created a new promotion!</div>
        </div>
      </b-col>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Send Email</strong>
          </div>
          <b-form @submit.prevent="createPromotion">
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <label for="promotion_name">Name</label>
                  <b-form-input
                    type="text"
                    v-validate="'required'"
                    v-model="promotion.promotion_name"
                    name="promotion_name"
                    placeholder="Enter your promotion name"
                    :class="{'has-error': errors.has('promotion_name')}"
                  >
                  </b-form-input>
                  <span class="red">{{ errors.first('promotion_name') }}</span>
                </b-form-group>
              </b-col>
            </b-row>
          <b-form-group
            label="Select Device"
            label-for="basicSelect">
            <b-form-select id="basicSelect"
              v-model="promotion.device_id"
              :plain="true"
              :options="devices"
              value="Please select">
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="Frequency">
            <b-form-select v-model="promotion.frequency"
              :plain="true"
              :options="frequencyList"
              value="Please select">
            </b-form-select>
          </b-form-group>
          <!-- <b-form-group
            label="Select MailChimp List">
            <b-form-select v-model="promotion.mailchimp_list"
              :plain="true"
              :options="mailchimpLists"
              value="Please select">
            </b-form-select>
          </b-form-group>
        -->
          <b-form-group>
            <label>Email Message</label>
            <quill-editor
              v-model="promotion.message"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)">
            </quill-editor>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox1" v-model="promotion.active">
              Set as Active
            </b-form-checkbox>
            <div class="grey">*Note: setting a promotion to be active will set all existing promotions connected to the device to be inactive.</div>
          </b-form-group>
          <div class="form-actions">
            <b-button type="submit" name="submit" variant="primary">Submit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'RegisterDevice',
  components: {
    quillEditor
  },
  data () {
    return {
      content: '',
      editorOption: {
        // some quill options
        theme: 'snow'
      },
      devices: [],
      frequencyList: [
        'Once',
        'Once per Hour',
        'Once per Day',
        'Once per Week'
      ],
      mailchimpLists: [],
      promotion: {
        active: true,
        message: 'This is an example message.',
        promotion_name: ''
      },
      success: false
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
    contentCode () {
      return this.promotion.message
    }
  },
  methods: {
    onEditorBlur (quill) {
    },
    onEditorFocus (quill) {
    },
    onEditorReady (quill) {
    },
    onEditorChange ({ quill, html, text }) {
      this.content = html
    },
    /**
     * Submits the promotion details to the backend API.
     */
    createPromotion: function () {
      let self = this
      let promotion = this.promotion

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post(`${process.env.VUE_APP_API_URL}api/promotions`, {
            device_id: promotion.device_id,
            frequency: promotion.frequency,
            message: promotion.message,
            promotion_name: promotion.promotion_name,
            // criteria: promotion.criteria
            criteria: 'everyone'
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.promotion.promotion_id = response.data.promotion_id
              self.success = true
              window.scrollTo(0, 0)

              self.setActive()
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    },
    /**
     * Checks if the input is numeric.
     * @param {string} n - String represention of integer.
     */
    isNumeric (n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
    },
    /**
     * Sets the newly created promotion to be active in the backend API.
     */
    setActive () {
      if (this.promotion.active) {
        axios.put(`${process.env.VUE_APP_API_URL}api/promotions/set_active`, {
          device_id: this.promotion.device_id,
          promotion_id: this.promotion.promotion_id,
          active: this.promotion.active
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': localStorage.getItem('user-token')
          }
        })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
    /* getMailChimpLists: function (data) {
      let lists = []

      for (let i = 0; i < data.length; i++) {
        lists.push({
          value: data[i]['id'],
          text: data[i]['name']
        })
      }

      return lists
    } */
  },
  mounted () {
    let self = this

    axios.get(`${process.env.VUE_APP_API_URL}api/devices/`, {
      headers: {
        'x-access-token': localStorage.getItem('user-token')
      }
    })
      .then(function (response) {
        let data = response.data.data
        let devices = []

        for (let i = 0; i < data.length; i++) {
          devices.push({
            value: data[i]['device_id'],
            text: data[i]['company_name'] + ' - ' + data[i]['device_name']
          })
        }

        self.devices = devices
      })
      .catch(function (error) {
        console.log(error)
      })

    if (this.isNumeric(this.$route.query.device_id)) {
      this.promotion.device_id = this.$route.query.device_id
    }

    /* axios.get('https://www.doorsystemapi.com/api/promotions/mailchimp_lists', {
      headers: {
        'x-access-token': localStorage.getItem('user-token')
      }
    })
      .then(function (response) {
        self.mailchimpLists = self.getMailChimpLists(response.data.lists)
      })
      .catch(function (error) {
        console.log(error)
      }) */
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.grey {
  color: #666;
  padding-top: 10px;
}

.quill-code {
    border: none;
    height: auto;
    > code {
      width: 100%;
      margin: 0;
      padding: 1rem;
      border: 1px solid #ccc;
      border-top: none;
      border-radius: 0;
      height: 10rem;
      overflow-y: auto;
      resize: vertical;
    }
  }
</style>
